import { MembershipDurationsProps, stateStatusType } from "./actionType";

export interface FetchMembershipDurationState {
  isLoading: boolean;
  error: string | null;
  membershipDuration: MembershipDurationsProps[] | null; // list
  status: stateStatusType | null;
}

export interface GenericMembershipDurationState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
  delete: string | null;
}


export const initialFetchPackagesState: FetchMembershipDurationState = {
  isLoading: false,
  error: null,
  membershipDuration: null,
  status: null,
};

export const initialGenericMembershipDurationState: GenericMembershipDurationState = {
  isLoading: false,
  error: null,
  status: null,
  delete: null
};

export interface MembershipDurationState {
  fetchmembershipDurationState: FetchMembershipDurationState;
  genericMembershipDurationState : GenericMembershipDurationState
}

export const initialState: MembershipDurationState = {
  fetchmembershipDurationState: initialFetchPackagesState,
  genericMembershipDurationState:initialGenericMembershipDurationState
}

